if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.querySelector('button#ctm_form_reset').addEventListener('click',this.calcReset)
      }

      calcReset(event){
        const productInfo = event.currentTarget.closest('product-info');
        if (productInfo) {
          delete productInfo.dataset.calculatorMode;
          delete productInfo.dataset.customQuantityWidth;
          delete productInfo.dataset.customQuantityHeight;
          productInfo.querySelectorAll('#ctm_width, #ctm_height').forEach((input) => {
            input.readOnly = false;
            input.classList.remove('is-disabled');
          });
          productInfo.querySelector('.product_calculator_main')?.classList.remove('custom-quantity-mode');
          const sizeHeading = productInfo.querySelector('.sticker-size .font-body-bold');
          if (sizeHeading) sizeHeading.textContent = 'Sticker Size';
        }
        document.querySelectorAll('.product_calculator_main .ctm_fieald input').forEach((ele)=>{
          ele.value = '';
        })
        document.querySelector('.product:has(input[type=radio][value="CUSTOM SIZES"]:checked) .pro_opt_main label').click();
      }

      getSelectedPresetDimensions() {
        const selectedSize = this.querySelector(
          'fieldset.product-form__input[data-index="1"] input[type="radio"]:checked'
        );
        const sizeMatch = selectedSize?.value
          .replace(/["”]/g, '')
          .match(/\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);

        if (!sizeMatch) return null;
        return {
          width: Number(sizeMatch[1]),
          height: Number(sizeMatch[2])
        };
      }

      updateCustomQuantityAvailability() {
        const trigger = this.querySelector('[data-custom-quantity-trigger]');
        if (!trigger) return;

        const productInfo = this.closest('product-info');
        const dimensions = this.getSelectedPresetDimensions();
        const minWidth = Number(productInfo?.querySelector('#ctm_width')?.min || 0);
        const minHeight = Number(productInfo?.querySelector('#ctm_height')?.min || 0);
        const isAvailable = dimensions
          && dimensions.width >= minWidth
          && dimensions.height >= minHeight;

        trigger.closest('.custom-quantity').hidden = !isAvailable;
      }

      selectCustomQuantity(trigger) {
        const productInfo = this.closest('product-info');
        const dimensions = this.getSelectedPresetDimensions();
        const customSize = this.querySelector(
          'fieldset.product-form__input[data-index="1"] input[type="radio"][value="CUSTOM SIZES"]'
        );

        if (!productInfo || !dimensions || !customSize) return;

        productInfo.dataset.calculatorMode = 'custom-quantity';
        productInfo.dataset.customQuantityWidth = dimensions.width;
        productInfo.dataset.customQuantityHeight = dimensions.height;
        if (customSize.checked) {
          customSize.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          customSize.click();
        }
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.updateCustomQuantityAvailability();
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-custom-quantity-trigger]')) {
            this.selectCustomQuantity(event.target);
            return;
          }

          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
